import { Map, fromJS } from 'immutable'
import get from 'lodash/get'

import { selectActivity } from './selectors'
import * as actions from './actions'

export const initialState = Map()

export default function (state = initialState, action) {
  const { type, payload } = action
  switch (type) {
    case actions.COMMUNITY_SET_FEED: {
      const { data } = payload
      const errors = get(data, 'errors')
      if (errors) {
        return state.set('errors', fromJS(errors))
      }
      const uuid = get(data, 'feedUuid')
      return state.setIn(['feeds', uuid], fromJS(data))
    }
    case actions.COMMUNITY_SET_ACTIVITIES: {
      const { data } = payload
      const { feedUuid } = data
      const activities = fromJS(data.activities)
      return state.setIn(['feeds', feedUuid, 'activities'], activities)
        .setIn(['feeds', feedUuid, 'total'], data.total)
    }
    case actions.COMMUNITY_DELETE_DRAFT: {
      const { draftId } = payload
      const drafts = state.get('drafts', Map())
      return state.set('drafts', drafts.delete(draftId))
    }
    case actions.COMMUNITY_PUT_DRAFT: {
      const { draftId, draft } = payload
      return state.setIn(['drafts', draftId], draft)
    }
    case actions.COMMUNITY_GET_ACTIVITY: {
      const { id } = payload
      const data = { processing: true }
      const activity = selectActivity(state, id)
      return activity.id
        ? state : state.setIn(['activities', id], data)
    }
    case actions.COMMUNITY_PUT_ACTIVITY: {
      const { activityId, activity: a } = payload
      const activity = { ...a, processing: false }
      return state.setIn(['activities', activityId], activity)
    }
    case actions.COMMUNITY_UNMOUNT_PAGE: {
      return Map()
    }
    default:
      return state
  }
}
